export default "__VITE_ASSET__DZy5f23T__"